import React, { useState } from "react";
import { ChevronRight, ChevronDown, Database, Loader2, Lock } from "lucide-react";
import { stepLabel, prettySent, STEP_TONE } from "@/lib/mongoMcp";

// One lookup: "find · regez.visits · 12 rows · company acme", expandable to the exact query sent (lock included).
export function StepRow({ step, index }) {
    const [open, setOpen] = useState(false);
    const running = step.status === "running";
    const Chevron = open ? ChevronDown : ChevronRight;
    return (
        <div className="border border-white/10 rounded-md bg-[#050505]" data-testid={`mongo-step-${index}`}>
            <button type="button" onClick={() => !running && setOpen(!open)} disabled={running}
                data-testid={`mongo-step-toggle-${index}`}
                className="w-full flex items-center gap-2 px-3 py-2 text-left text-[11px] font-mono hover:bg-white/[0.03] transition-colors">
                {running ? <Loader2 className="w-3.5 h-3.5 animate-spin text-white/50" /> : <Chevron className="w-3.5 h-3.5 text-white/40" />}
                <Database className="w-3.5 h-3.5 text-[#A78BFA]" strokeWidth={1.5} />
                <span className="flex-1 truncate text-white/80" data-testid={`mongo-step-label-${index}`}>
                    {running ? `${step.tool} …` : stepLabel(step)}
                </span>
                {step.truncated && <span className="text-[9px] uppercase tracking-wider text-amber-300">truncated</span>}
                <span className={`text-[9px] uppercase tracking-wider px-1.5 py-0.5 rounded border ${STEP_TONE[step.status] || STEP_TONE.running}`}
                    data-testid={`mongo-step-status-${index}`}>{step.status}</span>
            </button>
            {open && (
                <div className="px-3 pb-3 space-y-2 border-t border-white/5" data-testid={`mongo-step-detail-${index}`}>
                    <div className="flex flex-wrap gap-x-4 gap-y-1 pt-2 text-[10px] font-mono text-white/50">
                        <span className="flex items-center gap-1"><Lock className="w-3 h-3" /> {step.lock}{step.lock_field ? ` (${step.lock_field})` : ""}</span>
                        {step.duration_ms != null && <span>{step.duration_ms} ms</span>}
                        {step.reconnects > 0 && <span>reconnected ×{step.reconnects}</span>}
                    </div>
                    {step.error && <div className="text-[11px] text-red-300/90 whitespace-pre-wrap" data-testid={`mongo-step-error-${index}`}>{step.error}</div>}
                    {step.sent && (
                        <pre className="text-[10px] font-mono text-white/70 bg-black/40 border border-white/5 rounded p-2 overflow-auto max-h-64"
                            data-testid={`mongo-step-sent-${index}`}>{prettySent(step.sent)}</pre>
                    )}
                </div>
            )}
        </div>
    );
}

export default function MongoSteps({ steps, title = "Lookups", testId = "mongo-steps" }) {
    const list = (steps || []).filter((s) => s && s.tool);
    if (!list.length) return null;
    return (
        <div className="space-y-1.5" data-testid={testId}>
            <div className="label-xs text-white/40">{title} · {list.length}</div>
            {list.map((s, i) => <StepRow key={s.id || i} step={s} index={i} />)}
        </div>
    );
}
